export const SIDEMENU_COLLAPSED_KEY = 'mv_sidemenu_collapsed' as const;

export const SIDEMENU_WIDTH = {
  collapsed: 64,
  expanded: 256,
  collapsedClass: 'w-16',
  expandedClass: 'w-64',
  collapsedMargin: 'ml-16',
  expandedMargin: 'ml-64',
  collapsedLeft: 'left-16',
  expandedLeft: 'left-64',
};

export const FLYOUT_POSITION = {
  collapsedLeft: 60,
  expandedLeft: 252,
  bridgeLeft: 40,
  bridgeWidth: 24,
  zIndex: 700,
  bridgeZIndex: 699,
};

export const SIDEMENU_Z_INDEX = {
  menu: 500,
  expandButton: 700,
  flyout: 700,
  flyoutBridge: 699,
};

export const ROOT_ADMIN_PAGES = [
  '/admin/clients',
  '/admin/users',
  '/admin/reports',
  '/admin/products',
] as const;
